// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SwitcherTwoToneSvg from "@ant-design/icons-svg/es/asn/SwitcherTwoTone";
import AntdIcon from '../components/AntdIcon';

var SwitcherTwoTone = function SwitcherTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SwitcherTwoToneSvg
  }));
};

SwitcherTwoTone.displayName = 'SwitcherTwoTone';
export default React.forwardRef(SwitcherTwoTone);